import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { resolveLoggedInHomePath } from '@insite-store360/auth-session';
import { LoginService } from '@insite-store360/services';

@Injectable({
    providedIn: 'root'
})
export class LoginGuard implements CanActivate {

    constructor(private auth: LoginService, private router: Router) { }

    canActivate(): boolean {
        if (this.auth.isLoggedIn()) {
            // Keep the user on their active project home (SPFT / PM / IntElux).
            // Always sending `/admin` → landing-page fights SPFT session navigation
            // and produces a landing ↔ SPFT redirect loop.
            try {
                sessionStorage.removeItem('host-login-redirect-lock');
            } catch {
                // ignore
            }
            localStorage.removeItem('lastVisitedRoute');
            void this.router.navigateByUrl(resolveLoggedInHomePath());
            return false;
        }
        return true;
    }
}
